<template>
  <el-dialog
    class="preview-dialog"
    :visible.sync="batchVisible"
    fullscreen
    :before-close="clearBatchInfo"
    center
  >
    <div class="dialog-container" v-loading="loading">
      <div class="flex card-container">
        <div class="card-container-left">
          <div class="status flex mr-12">
            <div class="dialog-label f_16">状态：</div>
            <div class="dialog-value f_18 dialog-operation">
              <div
                class="card-title"
                :style="{
                  color: getStatus(questionInfo.status, 'color')
                }"
              >
                {{ getStatus(questionInfo.status, "content") }}
              </div>
            </div>
          </div>
          <div class="card-top flex">
            <div class="f_18 mr-12">题目ID：{{ questionInfo.id }}</div>
            <div class="f_18 mr-12">优先级：P{{ questionInfo.priority }}</div>
            <div class="f_18 mr-12" style="flex:1;text-align:right;">
              第 {{ questionInfo.submit_count }} 次提交
            </div>
          </div>
          <div class="card-tag flex">
            <div>
              <span class="dialog-label">难度等级：</span>
              <span class="dialog-value">{{
                questionInfo.level === 1
                  ? "简单"
                  : questionInfo.level === 2
                  ? "普通"
                  : "困难"
              }}</span>
            </div>
            <div>
              <span class="dialog-label">题目类别：</span>
              <span class="dialog-value">{{
                questionInfo.question_type_label
              }}</span>
            </div>
            <div>
              <span class="dialog-label">建议最长答题时间：</span>
              <span class="dialog-value">{{ questionInfo.time_max }} 秒</span>
            </div>
            <div>
              <span class="dialog-label">题目来源：</span>
              <span class="dialog-value">{{
                questionInfo.source_type_label || "-"
              }}</span>
            </div>
          </div>
          <div class="dialog-content">
            <div class="dialog-flex">
              <div class="dialog-label">题干：</div>
              <markdown-it
                v-if="questionInfo.translator"
                class="dialog-value"
                :md="(questionInfo.translator['zh-cn'] || {}).stem"
              ></markdown-it>
            </div>
            <div
              class="dialog-flex"
              v-for="(option, optionIndex) in questionInfo.options"
              :key="optionIndex"
            >
              <div class="dialog-label">
                <div>选项 {{ optionIndex + 1 }}：</div>
                <div class="jk-green" v-if="option.correct">（正确答案）</div>
              </div>
              <markdown-it
                class="dialog-value"
                v-if="option.translator['zh-cn']"
                :md="option.translator['zh-cn'].option"
              ></markdown-it>
              <div class="dialog-value" v-else>-</div>
            </div>
            <div class="dialog-flex">
              <div class="dialog-label">解析：</div>
              <markdown-it
                class="dialog-value"
                v-if="questionInfo.translator['zh-cn']"
                :md="questionInfo.translator['zh-cn'].analysis"
              ></markdown-it>
              <div class="dialog-value" v-else>-</div>
            </div>
            <div class="dialog-flex mb-20">
              <div class="dialog-label">所属知识点：</div>
              <div class="dialog-value">
                <template>
                  <el-tag
                    class="mr-12 mb-4"
                    size="medium"
                    v-for="point in questionInfo.knowledge_points"
                    :key="point.knowledge_point_id"
                  >
                    {{ point.knowledge_point_name }}
                  </el-tag>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="card-container-right">
          <div class="f_18 mb-8">
            {{ batchType == "pass" ? "审核环节" : "质检环节" }}
          </div>
          <div class="basic-section" v-if="batchType == 'pass'">
            <div class="jk-page-h4 mb-8">
              审核标准：<el-link
                type="primary"
                target="_blank"
                :underline="false"
                href="https://jiker.feishu.cn/docs/doccnsCzNaz1JgziKr06tTjIHye"
                ><i class="el-icon-question"></i
              ></el-link>
            </div>
            <div class="column flex mb-12">
              <span
                class="column-item mb-4"
                v-for="(item, index) in standardContent"
                :key="index"
              >
                {{ item }}
              </span>
            </div>
            <div class="jk-page-h4 mb-8">提示：</div>
            <div class="dialog-container-tips mb-12">
              <div class="tips-item mb-4">操作后不可修改，状态不可逆。</div>
              <div class="tips-item mb-4">通过，该题目将进入质检环节</div>
              <div class="tips-item">不通过，将驳回给老师修改</div>
            </div>
            <div class="jk-page-h4">审核结论：</div>
            <div class="btn-box mb-12" v-if="questionInfo.status == 1">
              <el-button
                v-if="
                  authPermissions.includes(
                    'question.api.fuwu_admin.skill_question_review_task.questions.pass.update'
                  )
                "
                type="primary"
                size="mini"
                :loading="btnLoading"
                :disabled="disabled"
                @click="handlePassId(questionInfo.id)"
                >{{ buttonName }}</el-button
              >
              <el-button
                v-if="
                  authPermissions.includes(
                    'question.api.fuwu_admin.skill_question_review_task.questions.reject.update'
                  )
                "
                @click="handleRejectId(questionInfo.id)"
                type="danger"
                size="mini"
                >审核拒绝</el-button
              >
            </div>
            <dir class="mb-12" v-else>
              <div
                :style="{
                  color: getStatus(questionInfo.status, 'color')
                }"
              >
                {{ getStatus(questionInfo.status, "content") }}
              </div>
            </dir>
            <div v-if="batchType == 'default'">
              <el-button
                class="float mb-8"
                v-if="
                  authPermissions.includes(
                    'question.api.jiker_service_admin.skill_questions.verify_log_base.store'
                  )
                "
                @click="handleAddRecord('basic', questionInfo.id)"
                size="mini"
                >新增记录</el-button
              >
              <div class="card-top flex mb-8">
                <span>修改记录：</span
                ><span
                  class="count-record"
                  @click="
                    handleOpenRecord(
                      'basic',
                      questionInfo.id,
                      questionInfo.verity_count_base
                    )
                  "
                  >{{ questionInfo.verity_count_base }}次</span
                >
              </div>
            </div>
          </div>
          <div
            class="basic-section pro-section mt-4"
            v-if="batchType == 'pro_pass'"
          >
            <div class="jk-page-h4 mb-8">
              质检标准：
              <el-link
                type="primary"
                target="_blank"
                :underline="false"
                href="https://jiker.feishu.cn/docs/doccnJ8Nfe3tUaiOQKj5YBocjkh"
                ><i class="el-icon-question"></i
              ></el-link>
            </div>
            <div class="column flex mb-12">
              <div class="column-item mb-4">
                题目评分：
                <el-link
                  class="ml-12"
                  href="https://jiker.feishu.cn/sheets/shtcnPHpS2C2kis1ISc4WvKcz9g?sheet=c4d5ab"
                  target="_blank"
                  type="primary"
                  :underline="false"
                  style="color:#409eff;"
                  >评分标准</el-link
                >
              </div>
              <span
                class="column-item mb-4"
                v-for="(item, index) in standardContent"
                :key="index"
              >
                {{ item }}
              </span>
            </div>
            <div class="jk-page-h4 mb-8">提示：</div>
            <div class="dialog-container-tips mb-12">
              <div class="tips-item mb-4">操作后不可修改，状态不可逆。</div>
              <div class="tips-item mb-4">通过，终审老师对质检结果进行确认</div>
              <div class="tips-item">不通过，驳回给出题老师修改</div>
            </div>
            <div class="mb-8">
              <div class="jk-page-h4 mb-12">
                题目评分：<span
                  ><i
                    class="el-icon-document ml-4 f_16"
                    v-if="
                      authPermissions.includes(
                        'question.api.jiker_service_admin.skill_questions.verify_log_degree.index'
                      )
                    "
                    @click="handleOpenCount('prodegree', questionInfo.id)"
                  ></i>
                </span>
              </div>
              <el-radio-group
                class="radio-group ml-12 mb-8"
                size="mini"
                v-if="
                  authPermissions.includes(
                    'question.api.fuwu_admin.skill_question_review_task.questions.pass.update'
                  )
                "
                :disabled="questionInfo.status == 2 || questionInfo.status == 3"
                v-model="questionInfo.profession_level"
              >
                <el-radio-button
                  size="mini"
                  :label="level"
                  v-for="level in 10"
                  :key="level"
                ></el-radio-button>
              </el-radio-group>
            </div>
            <div class="jk-page-h4 mb-8">质检结论：</div>
            <div class="btn-box mb-12" v-if="questionInfo.status == 6">
              <el-button
                v-if="
                  authPermissions.includes(
                    'question.api.fuwu_admin.skill_question_review_task.questions.pass.update'
                  )
                "
                type="primary"
                size="mini"
                @click="handleProPassId(questionInfo.id)"
                :loading="btnLoading"
                :disabled="disabled"
                >{{ buttonName }}</el-button
              >
              <el-button
                v-if="
                  authPermissions.includes(
                    'question.api.fuwu_admin.skill_question_review_task.questions.reject.update'
                  )
                "
                @click="handleProRejectId(questionInfo.id)"
                type="danger"
                size="mini"
                >质检不通过</el-button
              >
            </div>
            <div class="mb-12" v-else>
              <div
                :style="{
                  color: getStatus(questionInfo.status, 'color')
                }"
              >
                {{ getStatus(questionInfo.status, "content") }}
              </div>
            </div>
            <!-- <div v-if="batchType == 'default'">
              <el-button
                class="float mb-8"
                size="mini"
                v-if="
                  authPermissions.includes(
                    'question.api.jiker_service_admin.skill_questions.verify_log_pro.store'
                  )
                "
                @click="handleAddRecord('pro', questionInfo.id)"
                >新增记录</el-button
              >
              <div class="card-top flex mb-8">
                <span>修改记录：</span
                ><span
                  class="count-record"
                  @click="
                    handleOpenRecord(
                      'pro',
                      questionInfo.id,
                      questionInfo.verity_count_pro
                    )
                  "
                  >{{ questionInfo.verity_count_pro }}次</span
                >
              </div>
            </div> -->
          </div>
          <div class="jk-page-h4 mb-12" v-if="reject_logs.length">
            驳回记录：
          </div>
          <div class="reject-box" v-if="reject_logs.length">
            <div
              class="reject-content"
              v-for="(log, index) in reject_logs"
              :key="index"
            >
              <div class="reject-title" style="color:rgb(64, 158, 255);">
                {{ log.status }}
              </div>
              <div class="reject-item">
                <div class="reject-title">驳回理由：</div>
                <markdown-it
                  class="reject-markdown"
                  :md="
                    formatterRejectReason(
                      log.deprecate_reason_type_label,
                      log.description
                    )
                  "
                ></markdown-it>
              </div>
            </div>
          </div>
          <el-button
            class="w-170 fixed-btn"
            size="medium"
            @click="getVerifyQuestion"
            >下一题<i class="el-icon-right ml-8"></i
          ></el-button>
        </div>
      </div>
    </div>
    <!-- <skill-question-audit-record-dialog
      ref="recordDialog"
      :type="type"
      :currentId="questionInfo.id"
      :count="currentCount"
      :isEdit="isEdit"
      @updateCount="handleUpdateCount"
      :visible.sync="recordDialogVisible"
    ></skill-question-audit-record-dialog>
    <skill-question-audit-count-dialog
      ref="countDialog"
      :type="type"
      :currentId="questionInfo.id"
      :count="currentCount"
      :visible.sync="countDialogVisible"
    ></skill-question-audit-count-dialog> -->
    <question-audit-discard-dialog
      :discardVisible.sync="discardVisible"
      :currentId="questionInfo.id"
      @updateStatus="handleUpdateStatus"
      :rejectType="rejectType"
      :title="discardTitle"
      :spendTime="timer"
      :countdownTime="countdownTime"
    ></question-audit-discard-dialog>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import skillService from "@/global/service/skill";
import QuestionAuditDiscardDialog from "./QuestionAuditDiscardDialog.vue";

export default {
  components: {
    MarkdownIt,
    QuestionAuditDiscardDialog
  },
  props: {
    BatchArr: {
      default: () => [],
      type: Array
    },
    batchVisible: {
      default: false,
      type: Boolean
    },
    batchType: {
      type: String,
      default: "pro_pass"
    },
    query: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    BatchArr(val) {
      if (val) {
        this.BatchList = [...val];
      }
    },
    batchVisible(val) {
      if (val) {
        this.getVerifyQuestion();
      }
    }
  },
  data() {
    return {
      BatchList: [],
      identity: null,
      type: "basic",
      rejectType: "reject",
      discardTitle: "",
      recordDialogVisible: false,
      countDialogVisible: false,
      isEdit: false,
      loading: false,
      currentIndex: null,
      currentCount: null,
      degree: null,
      discardVisible: false,
      btnLoading: false,
      questionInfo: {
        options: [],
        translator: {}
      },
      reject_logs: [],
      questionId: null,
      page: 1,
      timer: null,
      timerInterval: null,
      buttonName: null,
      disabled: false,
      countDownInterval: null,
      countdownTime: 0
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    getStatus() {
      return (status, type) => {
        let color, content;
        switch (status) {
          case 1:
            color = "#E6A23C";
            content = "已提交待审核";
            break;
          case 2:
            content = "通过入库";
            color = "#67C23A";
            break;
          case 3:
            content = "质检不通过";
            color = "#F56C6C";
            break;
          case 4:
            content = "题目下架";
            color = "#909399";
            break;
          case 6:
            content = "审核通过待质检";
            color = "#409EFF";
            break;
          case 7:
            content = "审核不通过";
            color = "#F56C6C";
            break;
          case 9:
            content = "质检通过待终审";
            color = "#409eff";
            break;
          case 10:
            content = "题目作废";
            color = "#f56c6c";
            break;
        }
        return type == "color" ? color : content;
      };
    },
    standardContent() {
      // 质检
      if (this.batchType === "pro_pass") {
        return [
          "题目符合实效性（最新版本或主流版本），没有版本依赖",
          "题干清晰无歧义",
          "考察核心知识点",
          "代码格式正确，可运行 ，无多余转义字符",
          "四个选项设置合理，选项需具有干扰性，不存在明显二选一",
          "答案正确",
          "答案解析合理",
          "知识点关联合理（题目与知识点对应）",
          "题目难度设置合理（简单、普通、困难）"
        ];
        // 审核
      } else {
        return [
          "题干清晰通顺无歧义，无错别字，无超链接，图片清晰无水印",
          "专有名词书写格式校验（ 如：MySQL、MongoDB ）",
          "四个选项设置合理、无序号、无方向指示词（如ABC，以上都对）",
          "题目类别设置合理（概念题、代码题、场景题、其他）",
          "建议答题时间合理（60～120S）"
        ];
      }
    }
  },
  created() {
    this.BatchList = [...this.BatchArr];
    this.identity = this.$route.query.identity;
  },
  methods: {
    formatterRejectReason(arr, reason) {
      let targetInfo = "";
      arr.forEach(item => {
        targetInfo += "* " + item + "</br> \n";
      });
      targetInfo += "* " + reason;
      return targetInfo;
    },
    clearBatchInfo() {
      this.page = 1;
      clearInterval(this.timerInterval);
      clearInterval(this.countDownInterval);

      this.questionId = null;
      this.$emit("clearBatchInfo");
      this.$emit("update:batchVisible", false);
    },
    handleSimilarDetail(arr) {
      let url = this.$router.resolve({
        name: "SkillAll",
        query: {
          topic_id: arr.join(",")
        }
      });
      window.open(url.href);
    },
    handleCopyId(id) {
      const input = document.createElement("input");
      input.value = id;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    goDetail(id) {
      let routeUrl = this.$router.resolve({
        name: "SkillLibraryDetail",
        params: { id }
      });
      window.open(routeUrl.href, "_blank");
    },
    handleAddRecord(type) {
      this.recordDialogVisible = true;
      this.type = type;
      this.isEdit = true;
    },
    handleOpenRecord(type, id, count) {
      const permission =
        this.authPermissions.includes(
          "question.api.jiker_service_admin.skill_questions.verify_log_base.index"
        ) ||
        this.authPermissions.includes(
          "question.api.jiker_service_admin.skill_questions.verify_log_pro.index"
        );
      if (permission) {
        this.recordDialogVisible = true;
        this.currentCount = count;
        this.type = type;
        this.isEdit = false;
      }
    },
    handlePassId(id) {
      this.btnLoading = true;
      const params = {
        spend_time: this.timer,
        countdown_time: this.countdownTime
      };
      skillService
        .skillQuestionReviewTaskTypeQuestionPass(1, id, params)
        .then(res => {
          this.questionInfo.status = res.status;
          this.page--;
          clearInterval(this.timerInterval);

          this.$message.success("操作成功");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleOpenCount(type, id, count) {
      const permission =
        this.authPermissions.includes(
          "question.api.jiker_service_admin.skill_questions.verify_count_base.index"
        ) ||
        this.authPermissions.includes(
          "question.api.jiker_service_admin.skill_questions.verify_log_degree.index"
        ) ||
        this.authPermissions.includes(
          "question.api.jiker_service_admin.skill_questions.verify_count_pro.index"
        );
      if (permission) {
        this.countDialogVisible = true;
        this.type = type;
        this.currentCount = type == "prodegree" ? 0 : count;
      }
    },
    handleChangeProdegree(degree, id) {
      const params = {
        degree
      };
      skillService.addProdegreeRecord(id, params).then(() => {
        this.$message.success(`设置成功，目前题目评分为${degree}`);
      });
    },
    getSkillQuestionStatus(type) {
      this.recordDialogVisible = true;
      this.type = type;
      this.isEdit = false;
    },
    handleUpdateCount() {
      if (this.type == "basic") {
        this.questionInfo.verity_count_base += 1;
      } else {
        this.questionInfo.verity_count_pro += 1;
      }
    },

    handleRejectId() {
      this.rejectType = "reject";
      this.discardTitle = "审核不通过";
      this.discardVisible = true;
    },
    handleOpenDiscard() {
      this.discardVisible = true;
    },
    handleProPassId(id) {
      if (!this.questionInfo.profession_level) {
        return this.$message.error("请先给题目评分");
      }
      this.btnLoading = true;
      const params = {
        profession_level: this.questionInfo.profession_level,
        spend_time: this.timer,
        countdown_time: this.countdownTime
      };
      skillService
        .skillQuestionReviewTaskTypeQuestionPass(2, id, params)
        .then(res => {
          this.questionInfo.status = res.status;
          this.page--;
          this.$message.success("操作成功");
          this.btnLoading = false;
          clearInterval(this.timerInterval);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleProRejectId() {
      this.rejectType = "pro_reject";
      this.discardTitle = "质检不通过";
      this.discardVisible = true;
    },
    handleUpdateStatus(e) {
      clearInterval(this.timerInterval);
      this.questionInfo.status = e.status;
      this.page--;
    },
    getVerifyQuestion() {
      this.loading = true;
      const params = this.query;
      params.page = this.page;
      params.page_size = 1;
      clearInterval(this.timerInterval);
      clearInterval(this.countDownInterval);
      const type = this.batchType === "pass" ? 1 : 2;
      skillService
        .skillQuestionReviewTaskTypeQuestions(type, params)
        .then(res => {
          if (res.id == this.questionId || !res.id || res === null) {
            this.loading = false;
            return this.$message.info("该条件下暂无待审核题目");
          }
          this.countdownTime =
            res.time_max / 2 + Math.floor(Math.random() * 20) + 1;
          this.countDownChange(this.countdownTime);
          this.handleTimer();
          this.reject_logs = res.reject_logs;
          this.questionInfo = res;
          this.page++;
          this.questionId = res.id;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleTimer() {
      this.timer = 0;
      this.timerInterval = setInterval(() => {
        this.timer += 1;
      }, 1000);
    },
    countDownChange(time) {
      this.disabled = true;
      this.buttonName = `${
        this.batchType == "pass" ? "审核通过" : "质检通过"
      }(${time}) `;
      if (this.identity == "jiker") {
        this.disabled = false;
        return;
      }
      this.countDownInterval = setInterval(() => {
        time -= 1;
        this.buttonName = ` ${
          this.batchType == "pass" ? "审核通过" : "质检通过"
        }(${time})`;
        if (time <= 0) {
          this.buttonName = this.batchType == "pass" ? "审核通过" : "质检通过";
          this.disabled = false;
          clearInterval(this.countDownInterval);
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
.reject-box {
  overflow-y: auto;
  height: 120px;
  width: 100%;
  padding: 4px 0px;
  font-size: 14px;
  /deep/.jiker-markdown-it {
    p {
      line-height: 16px;
    }
  }
  .reject-title {
    width: 70px;
  }
  .reject-item {
    display: flex;
  }
  .reject-content {
    margin-bottom: 10px;
  }
  .reject-markdown {
    padding-top: 3px;
    width: calc(100% - 70px);
    p {
      word-wrap: break-word;
      word-break: break-all;
    }
  }
}
.f_16 {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 65%);
}
.f_18 {
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 75%);
}
.flex {
  display: flex;
  .flex-none {
    flex: none;
    padding-top: 24px;
    width: 85px;
  }
  .flex-1 {
    flex: 1;
  }
}
.preview-dialog {
  /deep/.el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      .el-dialog__close.el-icon-close {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }
  }
  /deep/.el-dialog__body {
    padding: 0px 0 0px 10px;
  }
}
.dialog-container {
  .card-container {
    display: flex;
  }
  .card-container-left {
    flex: 1;
    border-right: 1px solid #dcdfe6;
    padding: 16px 0 10px;
    height: 100vh;
    overflow-y: auto;
    .status {
      float: right;
      align-items: center;
    }
    .card-top {
      padding: 0 20px 10px;
      align-items: center;
      .card-title {
        font-size: 18px;
        font-weight: 500;
      }
      i[class*="el-icon-"] {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .card-tag {
      justify-content: space-between;
      font-size: 14px;
      background: rgb(217, 236, 255);
      padding: 5px 10px;
      color: rgba(0, 0, 0, 65%);
      .dialog-label {
        font-weight: 500;
      }
    }
  }
  .card-container-right {
    padding: 10px 40px 10px 16px;
    width: 350px;
    .float {
      float: right;
    }
    .basic-section {
      padding: 10px 0;
      &.pro-section {
        border-bottom: none;
        padding: 10px 0 0;
      }
      .radio-group {
        /deep/.el-radio-button__inner {
          padding: 5px 8px;
        }
      }
    }
    .flex {
      align-items: center;
      &.column {
        flex-direction: column;
        align-items: flex-start;
        .column-item {
          position: relative;
          padding-left: 20px;
          display: flex;
          &::before {
            position: absolute;
            content: "";
            top: 8px;
            left: 10px;
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 65%);
          }
        }
        .column-item_second {
          position: relative;
          padding-left: 40px;
          &::before {
            position: absolute;
            content: "";
            top: 8px;
            left: 25px;
            // transform: translateY(-50%);
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 65%);
            // background: rgba(0, 0, 0, 65%);
          }
        }
      }
    }
    .card-top {
      height: 28px;
      margin-right: 10px;
      .count-record {
        cursor: pointer;
        color: #409eff;
      }
    }
    .card-title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(0, 0, 0, 65%);
    }
    .card-button {
      width: 100%;
      justify-content: flex-end;
    }
  }
  .dialog-content {
    margin: 0 auto;
    width: 700px;
    position: relative;
    .el-icon-copy-document {
      position: absolute;
      top: 0px;
      right: -80px;
      font-size: 18px;
      cursor: pointer;
    }
    .dialog-flex {
      display: flex;
      margin: 12px 0;
      .dialog-label {
        flex: none;
        width: 100px;
        text-align: right;
      }
      .dialog-value {
        flex: 1;
        &.jiker-markdown-it {
          padding: 0;
        }
        &.dialog-operation {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
.btn-box {
  margin-top: 8px;
  display: flex;
  justify-content: center;
}
.dialog-container-tips {
  margin-top: 8px;
  color: #e6a23c;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .tips-item {
    position: relative;
    padding-left: 20px;
    text-align: left;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #e6a23c;
    }
  }
}
.fixed-btn {
  position: fixed;
  bottom: 20px;
  right: 0px;
  margin-right: 120px;
}
</style>
